module.exports = __webpack_public_path__ + "img/background-mainPage.e9a5f9e0.svg";